<template>
  <div class="information">
    <Description
      :detail-info="detailInfo"
    />
    <Dropshipping :moq="detailInfo?.minOrderQuantity" />
    <PriceRange
      :list="priceRangeList"
      :variants="selectedVariants"
    />
    <BulkDiscount class="information-bulk-discount" />
    <Attributes
      v-if="detailInfo"
      @check-sku="handleCheckSku"
      :detail-info="detailInfo"
    />
    <MoreService />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Description from './cpns/Description.vue'
import PriceRange from './cpns/PriceRange.vue'
import Attributes from './cpns/Attributes.vue'
import { useCurrencyStore } from '@/pinia/currency'
import { useProductDetail } from '../../../hooks/useProductDetail'
import { useShipStore } from '@/pinia/ship'
import Dropshipping from '../Dropshipping.vue'
import BulkDiscount from './cpns/BulkDiscount.vue'
import MoreService from './cpns/MoreService.vue'

const emits = defineEmits(['updateCarousel', 'calcShipFee', 'hasProcessing'])

const props = defineProps({
  detailInfo: {
    type: Object,
    default: () => ({})
  }
})

const { formatPriceRangeList } = useProductDetail()

const shipStore = useShipStore()

const currencyStore = useCurrencyStore()

const priceRangeList = ref([])

const selectedVariants = ref('')

const recordCheckedSku = ref(null)

const attributesRef = ref(null)

watch(() => [shipStore.country, shipStore.postCode, currencyStore.current], () => {
  getPriceRangeList(recordCheckedSku.value)
})

let firstTime = true
const handleCheckSku = (sku, index) => {
  selectedVariants.value = sku.valueTrans
  recordCheckedSku.value = sku

  getPriceRangeList(sku)

  // 判断当前sku是否是processing状态
  emits('hasProcessing', String(sku.skuId))

  if (!firstTime) {
    emits('updateCarousel', index)
  }
  firstTime = false
}

// 选择sku 更新区间价下的预估物流费
const getPriceRangeList = async (sku) => {
  const { priceRangeList: list } = await formatPriceRangeList(props.detailInfo.offerId, sku, props.detailInfo.categoryId)
  priceRangeList.value = list
}

defineExpose({
  attributesRef
})
</script>

<style lang='less' scoped>
.information {
  flex: 1;
  min-width: 373px;

  &-bulk-discount {
    margin-top: 16px;
  }
}
</style>
